module.exports = __webpack_public_path__ + "static/media/8L.013204d4.png";